<template>
    <PreOrderUnitDetail
        v-if="preOrderUnit && loaded"
        :pre-order-unit="preOrderUnit"
        :manufacturers="manufacturers"
        :selected-manufacturer="selectedManufacturer"
        :updating.sync="updating"
        @searchManufacturers="executeManufacturerSearch"
        @updateUnit="updateUnit"
    />
    <Page404 v-else-if="loaded" message="That Pre-Order unit was not found" />
</template>
<script>
import { mapState, mapActions } from "vuex";
import Page404 from "src/components/NotFoundPage.vue";
import store from "./_store";
import PreOrderUnitDetail from "./_components/PreOrderUnitDetail.vue";
import { mutations } from "src/global-store.js";

export default {
    name: "PreOrderUnitDetailModule",
    components: {
        PreOrderUnitDetail,
        Page404,
    },
    data() {
        return {
            selectedManufacturer: null,
            loaded: false,
            updating: false,
            manufacturers: [],
        };
    },
    computed: {
        ...mapState("$_preOrderUnit", {
            preOrderUnit: (state) => state.selectedPreOrderUnit,
        }),
    },
    beforeCreate() {
        this.$store.registerModule("$_preOrderUnit", store);
    },
    destroyed() {
        this.$store.unregisterModule("$_preOrderUnit");
    },
    async created() {
        await this.fetchPreOrderUnit({
            preOrderId: this.$route.params.preOrderId,
            unitId: this.$route.params.id,
        });
        this.selectedManufacturer = { ...this.preOrderUnit.manufacturer };

        mutations.setNavbarTitle(
            "Unit #" + this.preOrderUnit.unitId,
            this.preOrderUnit.customer?.name,
        );

        this.loaded = true;
    },
    methods: {
        ...mapActions("$_preOrderUnit", [
            "fetchPreOrderUnit",
            "updatePreOrderUnit",
        ]),
        ...mapActions("manufacturer", ["searchManufacturers"]),
        async updateUnit(unit) {
            this.updating = true;
            await this.updatePreOrderUnit(unit);
            this.updating = false;
        },
        async executeManufacturerSearch({ search, loading }) {
            loading(true);
            this.manufacturers = await this.searchManufacturers(search);
            loading(false);
        },
    },
};
</script>
